import { render, staticRenderFns } from "./vnm.vue?vue&type=template&id=0b500f7a&"
import script from "./vnm.vue?vue&type=script&lang=js&"
export * from "./vnm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports